import React, { useState, useEffect, useCallback, useContext } from 'react'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import * as actions from "../../actions/service";
import * as category from "../../actions/category";
import * as user from "../../actions/user";
import { connect } from "react-redux";
import { AuthContext } from '../../context/AuthContext';
import API from '../../utils/api';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';
import { useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import CheckoutOne from '../../page/checkout';

const timeSlots = [
  { name: '9.00 AM', value: '9.00', disabled: false },
  { name: '9.30 AM', value: '9.30', disabled: false },
  { name: '10.00 AM', value: '10.00', disabled: false },
  { name: '10.30 AM', value: '10.30', disabled: false },
  { name: '11.00 AM', value: '11.00', disabled: false },
  { name: '11.30 AM', value: '11.30', disabled: false },
  { name: '12.00 PM', value: '12.00', disabled: false },
  { name: '12.30 PM', value: '12.30', disabled: false },
  { name: '1.00 PM', value: '13.00', disabled: false },
  { name: '1.30 PM', value: '13.30', disabled: false },
  { name: '2.00 PM', value: '14.00', disabled: false },
  { name: '2.30 PM', value: '14.30', disabled: false },
  { name: '3.00 PM', value: '15.00', disabled: false },
  { name: '3.30 PM', value: '15.30', disabled: false },
  { name: '4.00 PM', value: '16.00', disabled: false },
  { name: '4.30 PM', value: '16.30', disabled: false },
  { name: '5.00 PM', value: '17.00', disabled: false },
  { name: '5.30 PM', value: '17.30', disabled: false },
  { name: '6.00 PM', value: '18.00', disabled: false },
  { name: '6.30 PM', value: '18.30', disabled: false },
  { name: '7.00 PM', value: '19.00', disabled: false },
  { name: '7.30 PM', value: '19.30', disabled: false },
  { name: '8.00 PM', value: '20.00', disabled: false },
  { name: '8.30 PM', value: '20.30', disabled: false },
  { name: '9.00 PM', value: '21.00', disabled: false },
  { name: '9.30 PM', value: '21.30', disabled: false }
]

const CartViewThree = (props) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  let arr;
  const { getAuthUser, isAuthenticated, getCurrentBranch } = useContext(AuthContext)
  const authUser = getAuthUser()
  const isAuthentic = isAuthenticated()
  const currentBranch = getCurrentBranch()

  const [data, setData] = useState([]);
  const [total, setTotal] = useState('');
  const [subTotal, setSubTotal] = useState(0);
  const [rewardPoints, setRewardPoints] = useState(0);
  const [pts2reddem, setPts2reddem] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [promodiscount, setPromoDiscount] = useState(0);
  const [promoCode, setPromoCode] = useState('');
  const [giftcardDiscount, setGiftcardDiscount] = useState(0);
  const [giftcard, setGiftcard] = useState('');
  const [myCart, setMycart] = useState(props.cartArray);
  const [loading, setLoading] = useState(false);
  const [orderID, setOrderID] = useState(uuidv4());
  const [couponServices, setCouponServices] = useState({});
  const [isCartUpdate, setIsCartUpdate] = useState(false);
  const [stripeOptions, setStripeOptions] = useState({});
  const [slots, setSlots] = useState(timeSlots);
  const [bookings, setBookings] = useState(props.cart ? props.cart : {});
  const [step, setStep] = useState(11)

  useEffect(() => {
    props.fetchCart(authUser?.id)
    props.getCart({ _id: authUser?.id });
    setMycart(props.cartArray);
    setData(_.uniqBy(props.checkoutCart, 'id'));
  }, [])

  useEffect(() => {
    if (props.checkoutCart.length < 1) {
      return
    }
  
    setData(_.uniqBy(props.checkoutCart, 'id'));
    // setMycart(props.cartArray)
  }, [props.checkoutCart])

  useEffect(() => {
    //if(props?.cartCoupon?.length>0){
    //   return;
    // }
    if (props?.cartCoupon && props?.cartCoupon[0]?.id) {
      //  let couponArr = props?.cartCoupon?.reduce((a, o) => (o.id && a.push(o.id), a), [])      

      let filteredcart = props?.cartCoupon.flatMap(i => i.services)
      var count = {};
      filteredcart.forEach(function (i) { count[i] = (count[i] || 0) + 1; });
      // console.log('props.cartCoupon------------',count)
      setCouponServices(count)
    }

  }, [props.cartCoupon])


  useEffect(() => {
    let totalPrice = 0;
    let rewardPoints = 0;
    let discount = 0
    data != null &&
      setSubTotal(
        data.map((item, index) => {
          totalPrice += item?.price * props.cart[item.id];
          //totalPrice += (item?.price - Math.round((item.discount / 100) * item?.price)) * props.cart[item.id];
          rewardPoints += item.loyalty_points * props.cart[item.id];

          discount +=
            item.type === 'package'
              ? (item.enabledGlobalDiscount) ? (item?.price - (item.price - _.round(((item.discount / 100) * item.price), 1))) * props.cart[item.id] : 0
              : (item?.price - (item?.price - Math.round((item.discount / 100) * item?.price))) * props.cart[item.id]
        }),
      );
    setSubTotal(totalPrice);
    setDiscount(discount);
    setRewardPoints(rewardPoints);
  }, [data]);



  useEffect(() => {

    // if (isFocused ) {
    onDebounceUpdateUserCart(myCart);
    // setMycart(myCart)
    setIsCartUpdate(false)
    // }

  }, [myCart]);

  const onDebounceUpdateUserCart = useCallback(_.debounce((cart) => {
    const onSuccess = () => {
      props.fetchCart(authUser.id)
      props.getCart({ _id: authUser.id });
    }
    props.updateUserCart(authUser.id, {
      cart: cart
    }, onSuccess)

  }, 900), []);


  const onPlus = (serviceID) => {
    setIsCartUpdate(true)
    setMycart(myCart.concat([serviceID]))

  };

  const onMinus = (serviceID) => {
    setIsCartUpdate(true)
    myCart.splice(myCart.findIndex(a => a === serviceID), 1);

    setMycart(_.without(myCart, _.find(myCart, serviceID)))

  };

  const getReferenceToken = async () => {
    let isnumber;
    console.log('bb1', bookings)
    Object.values(bookings).every((v) => {

      console.log(v)
      if (typeof v === 'number') {
        isnumber = true;


      }
    })
    if (isnumber) {

      Swal.fire('Oops!', "Choose appointment date and time for all treatments.", 'warning')
      return;
    }

    setLoading(true);
    let param = {
      amount: Math.round((subTotal - discount - promodiscount - giftcardDiscount - (total / 100)) * 100),
      currency: 'AED',
      metadata: {
        'name': authUser.firstName + ' ' + authUser.lastName,
        'email': authUser.email,
        'mobile': authUser.mobile,
        'OrderID': orderID
      }
    }


    API.utility().createPaymentIntent(param)
      .then(async (res) => {

        if (res.data.statusCode === 400) {
          Swal.fire('Oops!', res.data.raw.message, 'warning')
          setLoading(false);
          return;
        }

        // console.log(res.data, 'ooo', res?.data?.split('pi_').pop().split('_secret')[0])
        setOrderID(res?.data?.split('pi_').pop().split('_secret')[0])
        let options = {
          clientSecret: res.data
        }
        setStripeOptions(options)
        setLoading(false);
        //history.push("/checkout-one", options)
        window.scrollTo(0, 170);
        setStep(13)

        //  await initializePaymentSheet(res.data,res?.data?.split('pi_').pop().split('_secret')[0]);
      })
      .catch(err => console.log(err))


  };

  const onPromoCodeApply = () => {

    if (!promoCode) {
      Swal.fire('Oops!', "Promo Code is empty", 'warning')
      return;
    }

    API.promocode().getbypromocode({
      promoCode: promoCode
    })
      .then(res => {

        setPromoDiscount(res.data.discount);
        Swal.fire('Yay!', "Promo Code applied. You got discount of AED " + res.data.discount + ".", 'success')
      })
      .catch(err => {
        setPromoDiscount(0);
        Swal.fire('Oops!', "Invalid Promo Code", 'warning')
      });

  };

  const onGiftCardCodeApply = () => {

    if (!giftcard) {
      Swal.fire('Oops!', "Promo Code is empty", 'warning')
      return;
    }

    API.giftcardorder().fetchById(giftcard)
      .then(res => {
        console.log(res.data)
        if (res.data.redeemptionStatus === 'redeemed') {
          Swal.fire('Oops!', "Gift card already redeemed.", 'warning')
          return
        }
        setGiftcardDiscount(res.data.amount);
        Swal.fire('Yay!', "Gift card applied. You got discount of AED " + res.data.amount + ".", 'success')
      })
      .catch(err => {
        setGiftcardDiscount(0);
        Swal.fire('Oops!', "Invalid gift card", 'warning')
      });

  };

  const onRedeemRewardsApply = () => {

    if (pts2reddem > authUser.rewardPoints) {

      Swal.fire('Sorry!', "You have only " + authUser.rewardPoints + " loyalty points.", 'warning')
      setTotal('')
      return;
    }

    setTotal(pts2reddem)


  };

  const onDateChange = (date, id, index, time, serviceid) => {
    console.log(id, index, date,)
    //console.log(date.toISOString().split('T')[0],new Date().toISOString().split('T')[0])
    setSlots(timeSlots)

    API.order().getAvailableTimeSlots({
      bookingDate: new Date(date),
    })
      .then(res => {

        arr = res.data
        let sl = timeSlots;

        sl.forEach((ele, index) => {

          sl[index].disabled = false
          if (arr.includes(ele.value)) {
            sl[index].disabled = true
          }
          if (date === new Date().toISOString().split('T')[0]) {
            if (parseInt(ele.value) < parseInt(moment(new Date()).format("HH:mm")) + 0.60) {
              sl[index].disabled = true
            }

          }
        })
        setSlots(sl)

        console.log('slots', slots)
      })
      .catch(err => console.log(err))



    let booking = bookings

    if (serviceid) {


      let empty
      if (booking[id]?.constructor.name === 'Object') {
        empty = booking[id]
      } else {
        empty = {}
      }
      empty[serviceid] = empty[serviceid] ? empty[serviceid] : []
      //  empty[serviceid].splice(index,0,{
      //   "date": date,
      //   "time": time,

      // })
      empty[serviceid][index] = {
        "date": date,
        "time": time,
        "status": 'Pending'
      }
      booking[id] = empty
    } else {

      if (Array.isArray(booking[id])) {
        let empty = booking[id]
        empty[index] = {
          "date": date,
          "time": time,
        }
        booking[id] = empty
      } else {
        let empty = []
        for (var i = 0; i < booking[id]; i++) {
          if (index === i) {
            empty.push({
              "date": date,
              "time": time,

            })
          } else {
            empty.push({
              "date": '',
              "time": '',

            })
          }

        }
        booking[id] = empty
      }
    }
    setBookings(booking)
   
  };


  const paymentStatus = (isSuccess, result) => {
    console.log(isSuccess, result)

    if (isSuccess) {
      API.order().create({
        customer_name: authUser.firstName + ' ' + authUser.lastName,
        customer_email: authUser.email,
        customer_mobile: authUser.mobile,
        customer_id: authUser.id,
        transaction_no: orderID,
        transaction_amount: subTotal - discount - promodiscount - giftcardDiscount - (total / 100),
        promocode: promoCode,
        giftcard: giftcard,
        promocodeDiscount: promodiscount,
        giftcardDiscount: giftcardDiscount,
        subTotal: subTotal,
        discount: discount + promodiscount + giftcardDiscount + (total / 100),
        rewardPoints: rewardPoints,
        orderedServices: props.cart,
        orderedServicesRef: Object.keys(props.cart).map((key) => ({ key, count: props.cart[key] })),
        transaction_status: "success",
        // order_status: "pending",
        note: "",

        scheduledServices: bookings,
        order_status: 'scheduled'
      })
        .then(response => {
          const onSuccess = () => {
            setLoading(false);

            // history.push("/order-complete",response)
            //navigation.navigate(navigationNames.orderDetail, { transaction_no: response.data.orderID, transaction_status: "success" })
          }
          setStep(14)

          setMycart([])
          authUser.rewardPoints = authUser.rewardPoints ? authUser.rewardPoints : 0 + rewardPoints;
          props.updateUserCart(authUser.id, {
            cart: [],
            coupons: [],
            rewardPoints: authUser.rewardPoints
          }, onSuccess)

        })
    }
  }

  return (
    <>

      <section id="cart_area_three" className="py-5">

        <div className="container">
          <div className='row pb-5'>
            <div className='col-md-8 col-12 offset-lg-2'>
              <div className="md-stepper-horizontal orange">
                <div className={`md-step ${step === 11 ? "active" : ""}` + `${step > 11 ? " done" : ""}`}>
                  <div className="md-step-circle"><span>1</span></div>
                  <div className="md-step-title">{t('summary')}</div>
                  <div className="md-step-optional"></div>
                  <div className="md-step-bar-left"></div>
                  <div className="md-step-bar-right"></div>
                </div>
                <div className={`md-step ${step === 12 ? "active" : ""}` + `${step > 12 ? " done" : ""}`}>
                  <div className="md-step-circle"><span>2</span></div>
                  <div className="md-step-title">{t('bookappt')}</div>
                  <div className="md-step-optional"></div>
                  <div className="md-step-bar-left"></div>
                  <div className="md-step-bar-right"></div>
                </div>
                <div className={`md-step ${step === 13 ? "active" : ""}` + `${step > 13 ? " done" : ""}`}>
                  <div className="md-step-circle"><span>3</span></div>
                  <div className="md-step-title">{t('payment')}</div>
                  <div className="md-step-optional"></div>
                  <div className="md-step-bar-left"></div>
                  <div className="md-step-bar-right"></div>
                </div>

              </div>
            </div>
          </div>
          {step === 11 &&
            <div className="row">
              <div className="col-lg-8 col-md-12 col-sm-12 col-12">
                <div className="table_desc">
                  <div className="table_page table-responsive">
                    <table>
                      <thead>
                        <tr>

                          <th className="product_thumb">{t('image')}</th>
                          <th className="product_name">{t('name')}</th>
                          <th className="product_Type">{t('type')}</th>
                          <th className="product_total">{t('discount')}</th>
                          <th className="product-price">{t('price')}</th>
                          <th className="product_quantity">{t('quantity')}</th>

                        </tr>
                      </thead>
                      <tbody>
                        {data.length > 0 ? _.filter(data, data => data?.branch === currentBranch).map((item, index) => (
                          <tr key={item.id}>

                            <td className="product_thumb">
                              <Link to={{
                                pathname: `/treatments/${data.id}`, state: {
                                  service: item,
                                  cartArray: myCart,
                                  count: _.countBy(myCart)[item.id]
                                }
                              }}>
                                <img src={process.env.REACT_APP_IMG_URL + item.image} alt="img" />
                              </Link>
                            </td>
                            <td className="product_name">
                              <Link to={{
                                pathname: `/treatments/${data.id}`, state: {
                                  service: item,
                                  cartArray: myCart,
                                  count: _.countBy(myCart)[item.id]
                                }
                              }}>{item.title[i18n.language]}</Link>
                            </td>
                            <td className="product_total">
                              {item.type === 'product' && <span>{t('treatment')}</span>}
                              {item.type === 'item' && <span >{t('product')}</span>}
                              {item.type === 'package' && <span >{t('package')}</span>}
                              {item.type === 'coupon' && <span >{t('deal')}</span>}
                            </td>
                            <td className="product_total">{item.discount}%</td>
                            <td className="product-price">
                              {item.type === 'package' ?

                                <span className="new">{`${t('aed')} ${(item.enabledGlobalDiscount) ? item.price - _.round(((item.discount / 100) * item.price), 1) : item.price}`} {item.discount != 0 && item.enabledGlobalDiscount && <del className='price-muted font-weight-normal'> {t('aed')} {item.price} </del>} </span>

                                :

                                <span className="new">{`${t('aed')} ${(item.price - Math.round((item.discount / 100) * item.price))}`} {item.discount != 0 && <del className='price-muted font-weight-normal'> {t('aed')} {item.price} </del>} </span>

                              }

                            </td>
                            <td className="product_quantity">
                              <form id="product_count_form_two">
                                <div className="product_count_one">
                                  <div className="plus-minus-input">
                                    <div className="input-group-button">
                                      <button type="button" className="button" onClick={() => onMinus(item.id)}>
                                        <i className="fa fa-minus"></i>
                                      </button>
                                    </div>
                                    <input className="form-control" type="number" value={_.countBy(myCart)[item.id]} readOnly />
                                    <div className="input-group-button">
                                      <button type="button" className="button" onClick={() => onPlus(item.id)}>
                                        <i className="fa fa-plus"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </td>

                          </tr>
                        )) :
                          <></>
                        }


                      </tbody>
                    </table>
                  </div>
                </div>



              </div>
              <div className="col-lg-4 col-md-12">
                <div className="coupon_code left mb-30">
                  <h3>{t('coupon')}</h3>
                  <div className="coupon_inner">
                    <p>{t('entercoupon')}</p>
                    <div className="input-group mb-3">
                      <input type="text" className="form-control" placeholder={t('couponplaceholder')} onChange={(e) => setPromoCode(e.target.value)} disabled={promodiscount > 0} />
                      <div className="input-group-append">
                        {promodiscount > 0 ?
                          <button className="input-group-text theme-btn-one btn-black-overlay btn_sm" type="button" onClick={() => setPromoDiscount(0)}>{t('remove')}</button>
                          :
                          <button className="input-group-text theme-btn-one btn-black-overlay btn_sm" type="button" onClick={onPromoCodeApply}>{t('apply')}</button>
                        }



                      </div>
                    </div>
                    {promodiscount > 0 && <small className='text-adam'>{t('aed')} {promodiscount} {t('couponapplied')}</small>}

                  </div>
                </div>

                <div className="coupon_code left mb-30">
                  <h3>{t('redeemrewards')}</h3>
                  <div className="coupon_inner">
                    <p>{t('youhave')} {authUser.rewardPoints} {t('loyaltyptsinacc')}</p>
                    <div className="input-group mb-3">
                      <input type="text" className="form-control" value={pts2reddem} placeholder={`Enter Points`}
                        onChange={(e) => {
                          setPts2reddem(e.target.value)

                        }}
                        disabled={total > 0}
                      />
                      <div className="input-group-append">
                        {total > 0 ?
                          <button className="input-group-text theme-btn-one btn-black-overlay btn_sm" type="button" onClick={() => {
                            setPts2reddem(0)
                            setTotal(0)
                          }}>{t('remove')}</button>
                          :
                          <button className="input-group-text theme-btn-one btn-black-overlay btn_sm" type="button" onClick={onRedeemRewardsApply}>{t('apply')}</button>}


                      </div>
                    </div>

                  </div>
                </div>

                <div className="coupon_code left mb-30">
                  <h3>{t('redeemgiftcard')}</h3>
                  <div className="coupon_inner">
                    <p>{t('entergift')}</p>
                    <div className="input-group mb-3">
                      <input type="text" className="form-control" placeholder={t('giftplaceholder')} onChange={(e) => setGiftcard(e.target.value)} disabled={giftcardDiscount > 0} />
                      <div className="input-group-append">
                        {giftcardDiscount > 0 ?
                          <button className="input-group-text theme-btn-one btn-black-overlay btn_sm" type="button" onClick={() => setGiftcardDiscount(0)}>{t('remove')}</button>
                          :
                          <button className="input-group-text theme-btn-one btn-black-overlay btn_sm" type="button" onClick={onGiftCardCodeApply}>{t('apply')}</button>
                        }



                      </div>
                    </div>
                    {giftcardDiscount > 0 && <small className='text-adam'>{t('aed')} {giftcardDiscount} {t('giftapplied')}</small>}

                  </div>
                </div>

                <div className="coupon_code left">
                  <h3>Cart Total</h3>
                  <div className="total_cart_inner">

                    <form action="#!" id="total_cart_form_three">
                      <label className="custom_boxed pl-0">{t('subtotal')} <span className="rigth_cart">{t('aed')} {subTotal}</span>

                      </label>
                      <label className="custom_boxed pl-0">{t('discount')} <span className="rigth_cart">{t('aed')} {discount + + giftcardDiscount}</span>

                      </label>
                      <label className="custom_boxed pl-0">{t('redeemedpoints')} <span className="rigth_cart">{t('aed')} {total / 100}</span>

                      </label>
                      <h6 className="estimate_for_country">{t('estimate')}</h6>
                    </form>
                    <div className="total_catr_three_bottom">
                      <h5>{t('total')} <span className="rigth_cart">{t('aed')} {subTotal - discount - promodiscount - giftcardDiscount - (total / 100)}</span></h5>
                    </div>
                    {rewardPoints > 0 && <p className='small'>
                      {t('youwillearn')} {rewardPoints} {t('loyaltypoints')}
                    </p>}

                    <div className="cart_submit text-center">

                      {
                        loading ?
                          <a className="theme-btn-one btn-black-overlay btn_sm">{t('holdon')} <div className="spinner-border text-success spinner-border-sm"></div> </a>
                          :
                          <a onClick={() => {
                            setStep(12)
                            window.scrollTo(0, 170);
                          }} className="theme-btn-one btn-black-overlay btn_sm">{t('continue')}</a>
                      }

                    </div>

                  </div>
                </div>

              </div>
            </div>}

          {step === 12 &&
            <div className="row">
              <div className='col-lg-12'>
                {data.length > 0 && _.filter(data, data => data?.branch === currentBranch).map((item, index) => (
                  <div className='card mb-4 shadow-sm' key={item.id}>
                    <div className="card-body">
                      <div className='row'>
                        <div className='col-lg-2 col-4'>
                          <img src={process.env.REACT_APP_IMG_URL + item.image} className='shadow' />
                        </div>
                        <div className='col-lg-3 col-8'>
                          <p className='text-black'>{item.title[i18n.language]}</p>
                          <div className='discount badge cart-label font-weight-light text-capitalize mb-2'>

                            {item.type === 'product' && <span>{t('treatment')}</span>}
                            {item.type === 'item' && <span >{t('product')}</span>}
                            {item.type === 'package' && <span >{t('package')}</span>}
                            {item.type === 'coupon' && <span >{t('deal')}</span>}
                          </div>
                          <p>
                            {item.type === 'package' ?

                              <span>{`${t('aed')} ${(item.enabledGlobalDiscount) ? item.price - Math.round((item.discount / 100) * item.price) : item.price}`} {item.discount != 0 && item.enabledGlobalDiscount && <del className='price-muted'> {t('aed')} {item.price} </del>} </span>

                              :

                              <span >{`${t('aed')} ${(item.price - Math.round((item.discount / 100) * item.price))}`} {item.discount != 0 && <del className='price-muted '> {t('aed')} {item.price} </del>} </span>

                            }

                            {/* ({item.discount}%) */}

                            <p>Quantity: {_.countBy(myCart)[item.id]}</p>
                          </p>
                        </div>
                        <div className='col-lg-7 col-12'>
                          <div className='row'>
                            <div className='col-lg-12 col-12'>

                              {item.type !== 'package' && <div>
                                {Array(_.countBy(myCart)[item.id]).fill().map((e, i) => (
                                  <>

                                    <div className='row'>
                                      <div className='col-lg-2 d-flex justify-content-lg-center align-items-lg-center'>
                                        {t('booking')} {i + 1}
                                      </div>
                                      <div className='col-lg-5'>


                                        <div className="form-group">
                                          <label>{t('date')}</label>
                                          <input className="form-control" type="date" min={new Date().toISOString().split("T")[0]} onChange={(e) => onDateChange(e.target.value, item.id, i, bookings[item.id] && bookings[item.id][i] ? bookings[item.id][i].time : '')} />

                                          {/* <DatePicker className="btn-block form-control"
                                      minDate={new Date()}
                                      selected={new Date()}
                                      onChange={(date) => onDateChange(date, item.id, i, bookings[item.id] && bookings[item.id][i] ? bookings[item.id][i].time : '')} /> */}

                                        </div>
                                      </div>
                                      <div className='col-lg-5'>
                                        <div className="form-group">
                                          <label>{t('time')}</label>

                                          <select className="form-control"
                                            onChange={(e) => onDateChange(bookings[item.id][i] ? bookings[item.id][i].date : new Date(), item.id, i, e.target.value)}
                                          >
                                            <option>Choose</option>
                                            {slots.map((e, index) => <option key={index} value={e.value} disabled={e.disabled}>{e.name}</option>)}
                                          </select>
                                        </div>
                                      </div>

                                    </div>
                                  </>
                                ))}
                              </div>}

                              {item.type === 'package' && item.packageServices &&
                                item.packageServices.map((et, i) => (
                                  <div className='mb-2'>

                                    <div className='row mb-3'>
                                      <div className='col-lg-8 offset-lg-2'>
                                        <img src={process.env.REACT_APP_IMG_URL + et.serviceID.image} style={{
                                          height: 50, width: 50, objectFit: 'cover', marginRight: 15
                                        }} />
                                        {/* </div>
        <div className='col-lg-8'> */}
                                        <span >{et.serviceID.title[i18n.language]}</span>


                                      </div>
                                    </div>
                                    {Array(_.countBy(myCart)[item.id]).fill().map((e, i) => (

                                      <div className='row'>
                                        <div className='col-lg-2 d-flex justify-content-lg-center align-items-lg-center'>
                                          {t('booking')} {i + 1}
                                        </div>
                                        <div className='col-lg-5'>


                                          <div className="form-group">
                                            <label>{t('date')}</label>
                                            <input className="form-control" type="date" min={new Date().toISOString().split("T")[0]} onChange={(e) => onDateChange(e.target.value, item.id, i, (bookings[item.id] && typeof bookings[item.id][i] != 'undefined') ? bookings[item.id][i].time : '', et.serviceID.id)} />

                                            {/* <DatePicker className="btn-block form-control"
                                        minDate={new Date()}
                                        selected={bookings[item.id] && bookings[item.id][et.serviceID.id] && bookings[item.id][et.serviceID.id][i]?bookings[item.id][et.serviceID.id][i].date: new Date()}
                                        onChange={(date) => onDateChange(date, item.id, i, (bookings[item.id] && typeof bookings[item.id][i] != 'undefined')?bookings[item.id][i].time: '',et.serviceID.id)}
                                      /> */}

                                          </div>
                                        </div>
                                        <div className='col-lg-5'>
                                          <div className="form-group">
                                            <label>{t('time')}</label>

                                            <select className="form-control"
                                              onChange={(itemValue) => onDateChange(bookings[item.id] && bookings[item.id][et.serviceID.id] && bookings[item.id][et.serviceID.id][i] ? bookings[item.id][et.serviceID.id][i].date : new Date(), item.id, i, itemValue.target.value, et.serviceID.id)}

                                            >
                                              <option>Choose</option>
                                              {slots.map((e, index) => <option key={index} value={e.value} disabled={e.disabled}>{e.name}</option>)}
                                            </select>
                                          </div>
                                        </div>

                                      </div>

                                    ))}



                                  </div>

                                ))
                              }



                              <div className='col-lg-12'>

                                <small className="form-text text-muted">Date & time will be confirmed by our customer service agent</small>
                              </div>
                            </div>
                          </div>
                          {/* <div>
                          <form id="product_count_form_two">
                            <div className="product_count_one">
                              <div className="plus-minus-input">
                                <div className="input-group-button">
                                  <button type="button" className="button" onClick={() => onMinus(item.id)}>
                                    <i className="fa fa-minus"></i>
                                  </button>
                                </div>
                                <input className="form-control" type="number" value={_.countBy(myCart)[item.id]} readOnly />
                                <div className="input-group-button">
                                  <button type="button" className="button" onClick={() => onPlus(item.id)}>
                                    <i className="fa fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div> */}
                        </div>

                      </div>



                    </div>
                  </div>
                ))
                }
              </div>
              <div className="cart_submit text-center col-lg-12">

                {
                  loading ?
                    <a className="theme-btn-one btn-black-overlay btn_sm">{t('holdon')} <div className="spinner-border text-success spinner-border-sm"></div> </a>
                    :
                    <a onClick={() => getReferenceToken()} className="theme-btn-one btn-black-overlay btn_sm">{t('checkout')}</a>
                }

              </div>

            </div>}

          {step === 13 &&
            <CheckoutOne stripeOptions={stripeOptions} paymentStatus={paymentStatus} />
          }

          {step === 14 &&

            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="text-center order_complete">
                  <i className="fa fa-check-circle"></i>
                  <div className="order_complete_heading">
                    <h4>{t('ordercompleted')}</h4>
                  </div>
                  <p>{t('thanksorder')}</p>
                  <Link to={{ pathname: `/appointments` }} className="btn btn-lg bg-adam"><i className="fa fa-calendar-plus-o"></i>  {t('appointments')}</Link>
                </div>
              </div>
            </div>

          }


        </div>
      </section>
    </>
  )
}



const mapStateToProps = state => ({
  services: state?.service?.services,
  meta: state?.service?.metaService,
  categories: state.category.categories,
  users: state.user.users,
  cart: state.user.cart,
  cartArray: state.user.cartArray,
  checkoutCart: state.user.checkoutCart,
  cartCoupon: state.user.coupons,
})

const mapActionToProps = {
  fetchAll: actions.fetchAll,
  update: actions.update,
  fetchCategories: category.fetchAll,
  updateUser: user.update,
  updateUserCart: user.updateCart,
  fetchCart: user.fetchCart,
  getCart: user.getCart
}

export default connect(mapStateToProps, mapActionToProps)(CartViewThree);